// Solutions — five industry categories. CMS-ready: add sectors here without touching components.
export const sectors = [
  {
    slug: "financial-services", name: "Financial Services",
    desc: "ESG integration, responsible investment, portfolio assessment, climate risk and disclosure for banks, insurers, NBFCs and funds.",
    services: ["responsible-investment", "climate-risk", "esg-governance", "esg-investor-disclosure"],
  },
  {
    slug: "real-estate-infrastructure", name: "Real Estate & Infrastructure",
    desc: "Long-lived assets face decades of climate exposure — climate risk, energy, emissions, biodiversity and social impact.",
    services: ["climate-risk", "ghg-accounting", "biodiversity", "social-impact"],
  },
  {
    slug: "manufacturing", name: "Manufacturing",
    desc: "The most measurable environmental footprint and the clearest efficiency gains — carbon accounting, energy, water, waste and BRSR.",
    services: ["ghg-accounting", "water-resources", "environmental-strategy", "brsr"],
  },
  {
    slug: "energy", name: "Energy",
    desc: "At the centre of the transition — climate transition planning, GHG accounting, biodiversity and just-transition considerations.",
    services: ["net-zero", "climate-risk", "biodiversity", "esg-risk"],
  },
  {
    slug: "consumer-technology", name: "Consumer & Technology",
    desc: "Scope 3, packaging and circularity on one side; D&I, data governance and disclosure expectations on the other.",
    services: ["human-rights", "ghg-accounting", "diversity-inclusion", "sustainability-reporting"],
  },
];
